import React, { useEffect, useState } from "react";
import axiosClient from "../../axios-client";

const BillingHistory = () => {
  const userID = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const [subscriptions, setSubscriptions] = useState([]);

  const handleDownload = () => {
    const invoiceData = subscriptions.map(subscription => ({
      date: formatDate(subscription.startDate),
      description: `${subscription.plan.billingCycle} Subscription - ${subscription.plan.name}`,
      amount: `$${subscription.plan.price}`,
      status: subscription.status,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8,Bizwit Insight Invoice\n" +
      invoiceData.map((e) => Object.values(e).join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "invoices.csv");
    document.body.appendChild(link);

    link.click();
  };

  useEffect(() => {
    if (token) {
      const fetchSubscriptions = async () => {
        try {
          const response = await axiosClient.get(
            `/subscriptions/getSubscriptionsByUser/${userID}`
          );

          // console.log("Subscriptions:", response.data);
          // const reportDownload = response.data[0].plan.features.reportDownloads;
          if (
            response.data.length > 0 &&
            response.data[0].status === "Active"
          ) {
            setSubscriptions(response.data);
            console.log("Subscriptions:", subscriptions);
          }
        } catch (error) {
          console.error("Error fetching subscriptions:", error);
        }
      };
      fetchSubscriptions();
    }
  }, [token, userID]);

  const formatDate = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };

  return (
    <div className="border5 p-4">
      <h2 className="text-xl font-semibold">Billing History</h2>
      <p className="font4 mb-6">View your recent transactions and invoices.</p>

      <div className="overflow-x-auto mb-8">
        <table className="min-w-full table-auto">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 text-left">Date</th>
              <th className="px-4 py-2 text-left">Description</th>
              <th className="px-4 py-2 text-left">Amount</th>
              <th className="px-4 py-2 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {subscriptions.length > 0 ? (
              <tr className="border-b">
                <td className="px-4 py-2">{formatDate(subscriptions[0].startDate)}</td>
                <td className="px-4 py-2">{subscriptions[0].plan.billingCycle} Subscription - {subscriptions[0].plan.name}</td>
                <td className="px-4 py-2">${subscriptions[0].plan.price}</td>
                <td className="px-4 py-2">Active</td>
              </tr>
            ) : (
              <tr>
                <td className="px-4 py-2" colSpan="4">No billing history available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <button
        onClick={handleDownload}
        className=" border-black hover:bg-black hover:text-white font-medium  font4 py-2 px-4 rounded-md border"
      >
        Download All Invoices
      </button>
    </div>
  );
};

export default BillingHistory;
